// Small coloured badge for a workflow status or IP-risk level.

const TONE: Record<string, string> = {
  draft: 'badge badge--neutral',
  needs_review: 'badge badge--info',
  submitted_for_review: 'badge badge--info',
  reviewed: 'badge badge--good',
  approved: 'badge badge--good',
  completed: 'badge badge--good',
  rejected: 'badge badge--bad',
  failed: 'badge badge--bad',
  generating: 'badge badge--info',
  archived: 'badge badge--neutral',
  uploaded: 'badge badge--neutral',
  normalized: 'badge badge--info',
  green: 'badge badge--good',
  yellow: 'badge badge--warn',
  red: 'badge badge--bad',
};

export function StatusBadge({ status }: { status: string }) {
  const className = TONE[status] ?? 'badge badge--neutral';
  return <span className={className}>{status.replace(/_/g, ' ')}</span>;
}
